<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-home">
      <div class="flex-container row flex-align-center">
        <div class="bmw-lg-videos-home-title flex-65">
          Videos
        </div>
        <div class="flex">
          <form style="width:90%" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Find Video" name="techDoc" [(ngModel)]="search4videos">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true') , 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div>
        <div class="row bmw-no-gutter">
          <div
            *ngFor="let video of newVideos | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4videos |
            paginate: { itemsPerPage: 30, currentPage: page }">
            <div style="float: left; margin-right: 60px;user-select: none">
              <div class="pointer bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
                [queryParams]='{channel: video.channel.channelNumber, video: video.id,vimeoID: video.videoFileName, watchlist: false}'>
                <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
                <div class="bmw-lg-video-home-overlay-text"></div>
              </div>
              <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
                <div class="row bmw-no-gutter">
                  <div class="col-lg-10 bmw-no-gutter">
                    <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                    <div class="row bmw-no-gutter"
                      [innerHTML]='video.videoTitle.length > 43 ? video.videoTitle.substr(0,40)+"..." : video.videoTitle | highlightSearch: searchKey'>
                    </div>
                    <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                      {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}} views
                    </div>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons pointer" style="opacity: 0.7"
                      data-toggle="dropdown">more_vert</i>
                    <ul class="dropdown-menu">
                      <li class="row bmw-no-gutter pointer"
                        (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                        <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                          <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Add to watchlist
                        </div>
                      </li>
                      <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                        (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                        <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                          <i class="material-icons dp48" style="font-size:20px">share</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Share
                        </div>
                      </li>
                      <li class="divider"></li>
                      <li class="row bmw-no-gutter">
                        <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                          <i class="material-icons" style="font-size:20px">close</i>
                        </div>
                        <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                          Cancel
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div *ngIf='screenWidth > 991 && screenWidth < 1098'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-home md">
      <div class="flex-container row flex-align-center">
        <div class="bmw-lg-videos-home-title flex-65">
          Videos
        </div>
        <div class="flex">
          <form style="width:90%" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Find Video" name="techDoc" [(ngModel)]="search4videos">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true') , 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div>
        <div
          *ngFor="let video of newVideos | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4videos |
          paginate: { itemsPerPage: 30, currentPage: page }">
          <div class="pointer" style="float: left; margin-right: 12px;user-select: none">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <div class="bmw-lg-video-home-overlay-text"></div>
            </div>
            <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
              <div class="row bmw-no-gutter">
                <div class="col-md-10 bmw-no-gutter">
                  <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                  <div class="row bmw-no-gutter"
                    [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                  </div>
                  <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.numberOfViews}}
                  </div>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons pointer" style="opacity: 0.7"
                    data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent">
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-videos-home sm">
      <div class="flex-container row flex-align-center">
        <div class="bmw-xs-videos-home-title sm flex-55">
          Videos
        </div>
        <div class="flex">
          <form style="width:90%" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Find Videos" name="techDoc" [(ngModel)]="search4videos">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true') , 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="bmw-xs-videos">
        <div class="alert alert-danger" *ngIf="!newVideos">{{serviceError}}</div>
        <div class="row bmw-no-gutter"
          *ngFor="let video of newVideos  | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4videos |
          paginate: { itemsPerPage: 30, currentPage: page }"
          style="margin-bottom:7px">
          <div class="col-sm-4 bmw-no-gutter bmw-sm-video-home-thumbnail">
            <a [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" width="50px" height="50px" />
              <!-- <video height="84px" width="150px" [src]='video?.videoFileName'></video> -->
            </a>
          </div>
          <div class="col-sm-6 bmw-no-gutter" style="padding-left: 15px">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber | highlightSearch: searchKey'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle | highlightSearch: searchKey'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
              <div class="col-sm-6 bmw-no-gutter"
                [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div class="col-sm-6 bmw-no-gutter" [innerHTML]='video.numberOfViews'></div>
            </div>
          </div>
          <div class="col-sm-1 bmw-no-gutter">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter" data-toggle="modal" data-target="#shareContent">
                  <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-videos-home">
      <div class="flex-container bmw-xs-videos-home-title">
        Videos
      </div>
      <div class="flex-container">
        <form style="width:90%; margin: auto; margin-bottom: 25px" class="input-group" name="findDocs">
          <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
            placeholder="Find Videos" name="techDoc" [(ngModel)]="search4videos">
          <div class="input-group-btn">
            <button [ngClass]="{'mini-button-style' : (APP_SETTINGS.isMINI === 'true'),'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true') , 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}"
              class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div class="bmw-xs-results-content-service-bulletins">
        <div class="alert alert-danger" *ngIf="!newVideos">{{serviceError}}</div>
        <div class="row bmw-no-gutter"
          *ngFor="let video of newVideos | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4videos |
          paginate: { itemsPerPage: 30, currentPage: page }"
          style="margin-bottom:7px">
          <div class="col-xs-4 bmw-no-gutter bmw-xs-video-home-thumbnail">
            <a [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName,watchlist: false}'>
              <img src="{{videoThumbnail}}" width="50px" height="50px" />
              <!-- <video height="84px" width="150px" [src]='video?.videoFileName'></video> -->
            </a>
          </div>
          <div class="col-xs-6 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber | highlightSearch: searchKey'></div>
            <div class="row bmw-no-gutter"
              [innerHTML]='video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle | highlightSearch: searchKey'>
            </div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
              <div class="col-xs-6 bmw-no-gutter"
                [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
              <div class="col-xs-6 bmw-no-gutter" [innerHTML]='video.views'></div>
            </div>
          </div>
          <div class="col-xs-1 bmw-no-gutter">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent">
                  <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>